import { isEmpty } from 'lodash'

export const displayEmployeeRoles = (roles: string[] | []): string => {
  if (isEmpty(roles)) {
    return 'N/A'
  }

  // get manager and cashier roles
  const cashierRoles = roles?.filter((role) => role.toLowerCase() !== 'manager')
  const managerRoles = roles?.filter((role) => role.toLowerCase() === 'manager')

  // change initial names of cashier roles into display name "Cashier"
  const cashierRolesNames = cashierRoles.map(() => 'Cashier')

  const allRoles = [...managerRoles, ...cashierRolesNames]

  // return joined roles string
  const rolesToDisplay = allRoles.join(', ')

  return rolesToDisplay ?? ''
}
